import { css } from '@microsoft/fast-element';
import { getToken } from '../../design-tokens';
import { display } from '../../foundation/display';

export const loaderStyles = css`
    ${display('inline-flex')}

    @keyframes dots {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(.5);
        }
        100% {
            transform: scale(1);
        }
    }

    :host([appearance=dots]) div {
        --part: 0;
        --total: 0;
        width: calc(${getToken('space-design-unit')} * 3px);
        height: calc(${getToken('space-design-unit')} * 3px);
        border-radius: calc(${getToken('space-design-unit')} * 2px);
        background-color: currentColor;
        animation: 1s calc(var(--part) * 125ms) infinite ease-in-out dots;
    }

    :host([appearance=dots]) div + div {
        margin-left: calc(${getToken('space-design-unit')} * 1px);
    }

    @keyframes waves {
        0% {
            opacity: 0.25;
            height: calc(${getToken('space-design-unit')} * 1px);
            margin-top: calc(${getToken('space-design-unit')} * 2.5px);
        }
        50% {
            opacity: 1;
            height: calc(${getToken('space-design-unit')} * 10px);
            margin-top: 0%;
        }
        100% {
            opacity: 0.25;
            height: calc(${getToken('space-design-unit')} * 1px);
            margin-top: calc(${getToken('space-design-unit')} * 2.5px);
        }
    }

    :host([appearance=waves]) {
        display: block;
        height: calc(${getToken('space-design-unit')} * 10px);
    }

    :host([appearance=waves]) div {
        --half: round(down, var(--total) / 2);
        float: left;
        background: ${getToken('color-primary-base')};
        width: calc(${getToken('space-design-unit')} * 2px);
        height: calc(${getToken('space-design-unit')} * 1px);
        border-radius: calc(${getToken('space-design-unit')} * 2px);
        margin-top: calc(${getToken('space-design-unit')} * 2.5px);
        animation: 2.5s 0ms infinite linear waves;
    }

    :host([appearance=waves]) div:nth-child(1) { animation-delay: -1.4s; }
    :host([appearance=waves]) div:nth-child(2) { animation-delay: -1.2s; }
    :host([appearance=waves]) div:nth-child(3) { animation-delay: -1.0s; }
    :host([appearance=waves]) div:nth-child(4) { animation-delay: -0.8s; }
    :host([appearance=waves]) div:nth-child(5) { animation-delay: -0.6s; }
    :host([appearance=waves]) div:nth-child(6) { animation-delay: -0.4s; }
    :host([appearance=waves]) div:nth-child(7) { animation-delay: -0.2s; }
    :host([appearance=waves]) div:nth-child(8) { animation-delay: 0s; }
    :host([appearance=waves]) div:nth-child(9) { animation-delay: -0.2s; }
    :host([appearance=waves]) div:nth-child(10) { animation-delay: -0.4s; }
    :host([appearance=waves]) div:nth-child(11) { animation-delay: -0.6s; }
    :host([appearance=waves]) div:nth-child(12) { animation-delay: -0.8s; }
    :host([appearance=waves]) div:nth-child(13) { animation-delay: -1.0s; }
    :host([appearance=waves]) div:nth-child(14) { animation-delay: -1.2s; }
    :host([appearance=waves]) div:nth-child(15) { animation-delay: -1.4s; }

    :host([appearance=waves]) div + div {
        margin-left: calc(${getToken('space-design-unit')} * 1px);
    }
`;
